// @flow
export const HOME_ROUTE = '/';
export const SIGN_IN_ROUTE = '/signin';
export const USER_VEHICLES_ROUTE = '/user/vehicles';
export const VEHICLE_ROUTE = '/vehicle';
export const SERVICES_ROUTE = '/services';
export const DECLINED_SERVICES_ROUTE = '/declinedservices';
export const RECALL_SERVICES_ROUTE = '/recallservices';
export const RECALL_VIN_SEARCH_ROUTE = '/recallVinSearch';
export const INDIVIDUAL_SERVICES_ROUTE = '/individualservices';
export const APPOINTMENT_ROUTE = '/appointment';
export const REVIEW_ROUTE = '/review';
export const CONFIRMATION_ROUTE = '/confirmation';
export const CANCELLATION_ROUTE = '/cancellation';
export const MAINTENANCE_ROUTE = '/maintenance';
export const TRANSPORTATION_ROUTE = '/transportation';
export const DROPOFF_ROUTE = '/transportation/dropOff';
export const PICKUP_ROUTE = '/transportation/pickup';

export const DEEPLINK_PAGES = [
  HOME_ROUTE,
  VEHICLE_ROUTE,
  SERVICES_ROUTE,
  TRANSPORTATION_ROUTE,
  APPOINTMENT_ROUTE,
  REVIEW_ROUTE,
  USER_VEHICLES_ROUTE
];
export const PAGE_NAME_BY_ROUTE = Object.freeze({
  [HOME_ROUTE]: 'Start Page',
  [SIGN_IN_ROUTE]: 'Sign In Page',
  [USER_VEHICLES_ROUTE]: 'User Vehicles Page',
  [VEHICLE_ROUTE]: 'Vehicle Page',
  [SERVICES_ROUTE]: 'Services Page',
  [DECLINED_SERVICES_ROUTE]: 'Declined Services Page',
  [RECALL_SERVICES_ROUTE]: 'Recall Services Page',
  [RECALL_VIN_SEARCH_ROUTE]: 'Recall Vin Search Page',
  [INDIVIDUAL_SERVICES_ROUTE]: 'Individual Services Page',
  [DROPOFF_ROUTE]: 'Drop Off Page',
  [APPOINTMENT_ROUTE]: 'Date / Time Page',
  [REVIEW_ROUTE]: 'Review Page',
  [CONFIRMATION_ROUTE]: 'Confirmation Page',
  [CANCELLATION_ROUTE]: 'Cancellation Page',
  [MAINTENANCE_ROUTE]: 'Maintenance Page',
  [TRANSPORTATION_ROUTE]: 'Transportation Page',
  [PICKUP_ROUTE]: 'Pick Up Page'
});
// TODO: remove default messages once localization string are ready
export const ROUTES_ADA_TITLE_MAP = Object.freeze({
  [HOME_ROUTE]: {
    id: 'c8.ada.title.start.page',
    defaultMessage: 'Start Page'
  },
  [SIGN_IN_ROUTE]: {
    id: 'c8.ada.title.sign.in.page',
    defaultMessage: 'Sign In Page'
  },
  [USER_VEHICLES_ROUTE]: {
    id: 'c8.ada.title.user.vehicle.page',
    defaultMessage: 'User Vehicle Page'
  },
  [VEHICLE_ROUTE]: {
    id: 'c8.ada.title.vehicle.page',
    defaultMessage: 'Vehicle Page'
  },
  [SERVICES_ROUTE]: {
    id: 'c8.ada.title.services.page',
    defaultMessage: 'Services Page'
  },
  [DECLINED_SERVICES_ROUTE]: {
    id: 'c8.ada.title.declined.services.page',
    defaultMessage: 'Declined Services Page'
  },
  [RECALL_SERVICES_ROUTE]: {
    id: 'c8.ada.title.recall.services.page',
    defaultMessage: 'Recall Services Page'
  },
  [RECALL_VIN_SEARCH_ROUTE]: {
    id: 'c8.ada.title.recall.vin.search.page',
    defaultMessage: 'Recall Vin Search Page'
  },
  [INDIVIDUAL_SERVICES_ROUTE]: {
    id: 'c8.ada.title.individual.services.page',
    defaultMessage: 'Individual Services Page'
  },
  [APPOINTMENT_ROUTE]: {
    id: 'c8.ada.title.appointment.page',
    defaultMessage: 'Appointment Page'
  },
  [REVIEW_ROUTE]: {
    id: 'c8.ada.title.review.page',
    defaultMessage: 'Review Page'
  },
  [CONFIRMATION_ROUTE]: {
    id: 'c8.ada.title.confirmation.page',
    defaultMessage: 'Confirmation Page'
  },
  [CANCELLATION_ROUTE]: {
    id: 'c8.ada.title.cancellation.page',
    defaultMessage: 'Cancellation Page'
  },
  [MAINTENANCE_ROUTE]: {
    id: 'c8.ada.title.maintenance.page',
    defaultMessage: 'Maintenance Page'
  },
  [TRANSPORTATION_ROUTE]: {
    id: 'c8.ada.title.transportation.page',
    defaultMessage: 'Transportation Page'
  },
  [DROPOFF_ROUTE]: {
    id: 'c8.ada.title.transportation.page',
    defaultMessage: 'Transportation Page'
  },
  [PICKUP_ROUTE]: {
    id: 'c8.ada.title.pick.up.page',
    defaultMessage: 'Pick Up Page'
  }
});



// WEBPACK FOOTER //
// ./src/constants/routes.js